import React from 'react'
import Popover from 'shared/components/common/Popover/Popover.component'
import PopoverMenu from 'shared/components/common/Popover/components/Menu/Menu.component'
import PopoverItem from 'shared/components/common/Popover/components/Item/Item.component'

import styles from './Help.module.scss'

import iconDocs from 'shared/assets/icons/docs.svg'
import iconHelp from 'shared/assets/icons/help.svg'

const popoverItems = [
  { title: 'Docs for Graphs', icon: iconDocs, url: 'https://developer.khoros.com/khoros-flow/docs/other-actions-analytics' },
  { title: 'Docs for Exports', icon: iconDocs, url: 'https://developer.khoros.com/khoros-flow/docs/flow-analytics-metrics-and-definitions' }
]

const renderSecionItems = (items, onClick) => items.map((item, i) => (
  <PopoverItem
    key={i}
    title={item.title}
    icon={item.icon}
    onClick={onClick(item)}
  />
))

const Organisations = () => {
  let popover


  const onItemClick = item => () => {
    if(popover) popover.hide()

    window.open(
      item.url,
      '_blank'
    )
  }

  return (
    <main className={styles.wrapper}>
      <Popover
        ref={ref => popover = ref}
        trigger={<img className={styles.image} src={iconHelp} />}
        showChevron
        position='bottom-right'
      >
        <PopoverMenu>
          {renderSecionItems(popoverItems, onItemClick)}
        </PopoverMenu>
      </Popover>
    </main>
  )
}

export default Organisations
